{
  "sectionTitle": "Communities",
  "joinedAt": "Joined {{date}}",
  "leave": "Leave",
  "leaveTitle": "Leave community?",
  "leaveBody": "You will no longer see <strong>{{society}}'s</strong> events or be able to register for them. You can only rejoin with a new invitation.",
  "invite": {
    "subtitle": "Has invited you to join the community",
    "accept": "Accept",
    "accepted": "You joined the community {{society}}.",
    "decline": "Decline",
    "declineTitle": "Decline invitation?",
    "declineBody": "Decline the invitation to <strong>{{society}}</strong>? You can only join later with a new invitation."
  },
  "empty": {
    "title": "You don't belong to any communities yet",
    "description": "When you are invited to a community, the invitation will appear here. You can also join with a code."
  },
  "join": {
    "sectionTitle": "Join a community",
    "description": "Enter the community join code or scan a QR code to join.",
    "label": "Join a community with a code:",
    "labelMore": "Join a new community with a code:",
    "codePlaceholder": "Join code",
    "submit": "Join",
    "scanQr": "Scan QR code",
    "success": "You joined the community {{society}}.",
    "error": "Joining failed. Please check the code and try again.",
    "scanTitle": "Scan join code",
    "scanInstructions": "Point the camera at the community's QR code.",
    "scanCameraError": "Camera could not be accessed. Please check your camera permissions."
  },
  "joinLanding": {
    "title": "You are joining the community {{society}}",
    "description": "Joining requires an Impact account. Create an account or sign in to join automatically.",
    "createAccount": "Create account",
    "signIn": "Sign in",
    "confirmAs": "You are signed in as {{account}}. Would you like to join with this account?",
    "confirm": "Join",
    "invalidTitle": "Invalid link",
    "invalidBody": "The join link is invalid or has expired. Request a new link from the community. You can also join with a code on your profile page.",
    "errorTitle": "Something went wrong",
    "errorBody": "Failed to load the join link. Check your network connection and try again.",
    "retry": "Try again",
    "goHome": "Go to home page"
  }
}
